import { useEffect, useState } from "react";
import {
  ArrowRight,
  CheckCircle2,
  LoaderCircle,
  Plug,
} from "lucide-react";
import { EmptyState, PageHeader, useRouter } from "@tribunalea/ui";
import { useApi } from "../App.jsx";
import { integrationIcon } from "../integrations/registry.jsx";

export function IntegrationsPage() {
  const api = useApi();
  const { navigate } = useRouter();
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    api.listIntegrations()
      .then((result) => {
        if (active) setIntegrations(result);
      })
      .catch((requestError) => {
        if (active) setError(requestError.message);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [api]);

  return (
    <div className="page integrations-page">
      <PageHeader
        eyebrow="Praxis"
        title="Integraciones"
        description="Conectá Praxis con sistemas externos y consultá su información desde un mismo lugar."
      />

      {loading ? (
        <div className="integrations-loading">
          <LoaderCircle className="spin" size={24} />
          <span>Cargando integraciones…</span>
        </div>
      ) : error ? (
        <EmptyState
          icon={Plug}
          title="No pudimos cargar las integraciones"
          description={error}
        />
      ) : (
        <section className="integration-catalog">
          {integrations.map((item) => {
            const Icon = integrationIcon(item.type);
            return (
              <article className="integration-card" key={item.type}>
                <div className="integration-card-top">
                  <span className="integration-card-icon"><Icon size={24} /></span>
                  <span className={`integration-state ${
                    item.configured ? "is-configured" : ""
                  }`}>
                    {item.configured && <CheckCircle2 size={14} />}
                    {item.configured
                      ? item.configuredLabel
                      : "Disponible"}
                  </span>
                </div>
                <div>
                  <h2>{item.name}</h2>
                  <p>{item.description}</p>
                </div>
                {item.configured && (
                  <small>{item.configuredSummary}</small>
                )}
                <button
                  type="button"
                  onClick={() => navigate(item.route)}
                >
                  {item.configured
                    ? "Abrir integración"
                    : "Configurar"}
                  <ArrowRight size={16} />
                </button>
              </article>
            );
          })}
        </section>
      )}
    </div>
  );
}
